import { useController } from 'react-hook-form';
import { UncontrolledTextarea } from 'components/Form';
import { defaultDetail } from './VenueDetail';

const VenueInternalInstructionsEditMode = ({ fieldName, internalInstructions }) => {
  const { field } = useController({
    name: fieldName,
    defaultValue: internalInstructions,
    shouldUnregister: false,
  });
  return (
    <div className="field-container">
      <UncontrolledTextarea
        {...field}
        placeholder="Internal instructions just seen by Ontruck people"
        rows={5}
      />
    </div>
  );
};

const VenueInternalInstructionsRenderer = ({
  value: internalInstructions,
  isEditing,
  fieldName,
}) => {
  if (isEditing) {
    return (
      <VenueInternalInstructionsEditMode
        fieldName={fieldName}
        internalInstructions={internalInstructions}
      />
    );
  }

  if (!internalInstructions) {
    return <>{defaultDetail}</>;
  }

  if (typeof internalInstructions !== 'string') {
    return <>{defaultDetail}</>;
  }

  return <>{internalInstructions}</>;
};

export default VenueInternalInstructionsRenderer;
